import { createSlice } from "@reduxjs/toolkit";

const initialInsuranceState = {
    searchResult: null,
    clearAsyncResults: false,
    insuranceDataID: {
        insurance_carrier_id: null,
        location_id: null,
        adjuster_id: null
    },
    assignedInsurance: null
}

const insuranceSlice = createSlice({
    name: 'insurance',
    initialState: initialInsuranceState,
    reducers: {
        setSearchResult(state, data) {
            state.searchResult = data.payload
        },
        setClearAsyncResults(state, data) {
            state.clearAsyncResults = data.payload
        },
        setinsuranceDataID(state, data) {
            state.insuranceDataID[data.payload.identifier] = data.payload.data
            // state.insuranceDataID[data.payload.identifier] = data.payload.data.value
        },
        setFirmLocationInsuranceSelectionIndividual(state, data) {
            state.insuranceDataID[data.payload.identifier] = data.payload.data.value
        },
        removeinsuranceDataID(state) {
            state.insuranceDataID = {
                insurance_carrier_id: null,
                location_id: null,
                adjuster_id: null
            }
        },
        setAssignedInsurance(state, data) {
            state.assignedInsurance = []
            state.assignedInsurance.push(data.payload)
            // state.assignedAttorney = data.payload
        },
        removeAssignedInsurance(state) {
            state.assignedInsurance = null
        },
    }
})

export const insuranceActions = insuranceSlice.actions

export default insuranceSlice.reducer